const rawBase = process.env.REACT_APP_ZOOM_API_BASE || '';
const apiBase = rawBase.endsWith('/') ? rawBase.slice(0, -1) : rawBase;

function withBase(path) {
  if (!apiBase) return path;
  return `${apiBase}${path}`;
}

/**
 * Fetch active users by role. Used by meeting creation forms to populate
 * mentor / student pickers.
 */
export async function getUsersByRole(role) {
  const res = await fetch(withBase(`/api/users/by-role/${encodeURIComponent(role)}`), {
    headers: { Accept: 'application/json' },
  });
  let payload = {};
  try {
    payload = await res.json();
  } catch {
    payload = {};
  }
  if (!res.ok) {
    throw new Error(payload?.error || 'Unable to load users.');
  }
  return payload;
}

export async function createUser({ firstName, lastName, email, tagline }) {
  if (!firstName || !email) throw new Error('firstName and email are required');
  const res = await fetch(withBase('/api/users/create'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ firstName, lastName, email: email.trim().toLowerCase(), tagline }),
  });
  let payload = {};
  try {
    payload = await res.json();
  } catch {
    payload = {};
  }
  if (!res.ok) {
    throw new Error(payload?.error || 'Unable to create user.');
  }
  return payload;
}

export async function lookupUserByEmail(email) {
  if (!email) throw new Error('Email is required');
  const requestBody = { email: email.trim().toLowerCase() };
  const res = await fetch(withBase('/api/users/lookup'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(requestBody),
  });
  let payload = {};
  try {
    payload = await res.json();
  } catch {
    payload = {};
  }
  if (!res.ok) {
    throw new Error(payload?.error || 'Unable to lookup user.');
  }
  return payload;
}
